import React from "react";
import MuiDivider from "@mui/material/Divider";
import PropTypes from "prop-types";

/**
 * Divider component wrapper for visual separation.
 * Wraps Material-UI Divider with theme integration.
 * 
 * @component
 * @example
 * <Divider />
 * <Divider orientation="vertical" />
 */
const Divider = ({ children, ...props }) => {
  return <MuiDivider {...props}>{children}</MuiDivider>;
};

Divider.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.node,
  /**
   * Absolutely position the element
   */
  absolute: PropTypes.bool,
  /**
   * The component used for the root node
   */
  component: PropTypes.elementType,
  /**
   * If true, a vertical divider will have the correct height when used in flex container
   */
  flexItem: PropTypes.bool,
  /**
   * If true, the divider will have a lighter color
   */
  light: PropTypes.bool,
  /**
   * The divider orientation
   */
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  /**
   * The text alignment
   */
  textAlign: PropTypes.oneOf(["center", "left", "right"]),
  /**
   * The variant to use
   */
  variant: PropTypes.oneOf(["fullWidth", "inset", "middle"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

// No defaultProps - maintain exact MUI Divider behavior
// MUI Divider defaults: orientation="horizontal", variant="fullWidth"

export default Divider;

